import React from "react";
import { Sparkle } from "lucide-react";

const SPOTS = [
  { top: "8%", insetInlineStart: "6%", size: 12, delay: "0s", color: "#FFC83D" },
  { top: "18%", insetInlineEnd: "10%", size: 9, delay: "0.7s", color: "#27C9EE" },
  { top: "55%", insetInlineStart: "3%", size: 8, delay: "1.2s", color: "#FF63B5" },
  { bottom: "12%", insetInlineEnd: "6%", size: 11, delay: "1.8s", color: "#9C42F5" },
];

export default function Sparkles() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden rounded-3xl" aria-hidden="true">
      {SPOTS.map((s, i) => (
        <Sparkle key={i} className="absolute animate-twinkle" fill="currentColor"
          style={{ top: s.top, bottom: s.bottom, insetInlineStart: s.insetInlineStart, insetInlineEnd: s.insetInlineEnd, width: s.size, height: s.size, color: s.color, animationDelay: s.delay }} />
      ))}
    </div>
  );
}
